/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */
export const DATE_SEPARATOR = '><';
export const extractRangeFromString = (timeRange: string) => timeRange.split(DATE_SEPARATOR);
// from and until need to be in the user time zone.
export const timeRangeTitle = (from: string, until: string) => `${from || 'All time'} - ${until || 'Now'}`;
